import React, { useEffect, useRef, useState } from "react";
import { updateFuncionario } from "./FuncionarioService";
import ConfirmacaoModal from "./ConfirmacaoModal";
import { faCalendarDays, faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DivConfiguracaoAgendamento from "./DivConfiguracaoAgendamento";
import {
    atualizarConfiguracaoHorarioMedico,
    criarConfiguracaoHorarioMedico,
    excluirConfiguracaoHorarioMedico,
    getConfiguracoesHorarioMedicoPorUsuario,
} from "./ConfiguracaoHorarioMedicoService";
import { isConfiguracaoSemanal } from "./Helpers/AgendaValidation";

const criarHorarioConfiguracao = (key) => ({
    key,
    id: null,
    diasDaSemana: "",
    horaInicio: "00:00",
    horaFim: "00:00",
});

const normalizarHora = (hora) => (hora ? hora.substring(0, 5) : "00:00");

const mapearConfiguracaoHorario = (configuracao, key) => ({
    key,
    id: configuracao.id,
    diasDaSemana: configuracao.diasDaSemana,
    horaInicio: normalizarHora(configuracao.horaInicio),
    horaFim: normalizarHora(configuracao.horaFim),
});

const PerfilConfiguracaoModal = ({
    isModalOpen,
    onCloseModal,
    authResponseDTO,
    token,
}) => {
    const diasDaSemana = [
        { codigo: 0, nome: "Domingo", valor: "DOMINGO" },
        { codigo: 1, nome: "Segunda-feira", valor: "SEGUNDA_FEIRA" },
        { codigo: 2, nome: "Terça-feira", valor: "TERCA_FEIRA" },
        { codigo: 3, nome: "Quarta-feira", valor: "QUARTA_FEIRA" },
        { codigo: 4, nome: "Quinta-feira", valor: "QUINTA_FEIRA" },
        { codigo: 5, nome: "Sexta-feira", valor: "SEXTA_FEIRA" },
        { codigo: 6, nome: "Sábado", valor: "SABADO" },
    ];

    const [diasSelecionados, setDiasSelecionados] = useState(
        authResponseDTO.diasDeAtendimento,
    );
    const [exibeDropdownDiasDaSemana, setExibeDropdownDiasDaSemana] =
        useState(false);
    const [horariosConfiguracao, setHorariosConfiguracao] = useState([
        criarHorarioConfiguracao(0),
    ]);
    const [horariosRemovidos, setHorariosRemovidos] = useState([]);
    const proximoHorarioId = useRef(1);
    const [dadosDoUsuario, setDadosDoUsuario] = useState({
        username: authResponseDTO.username,
        cpfCnpj: authResponseDTO.cpfCnpj,
        telefone: authResponseDTO.telefone,
        email: authResponseDTO.email,
        dataDeNascimento: authResponseDTO.dataDeNascimento,
        documentoDeIdentificacao: authResponseDTO.documentoDeIdentificacao,
        funcao: authResponseDTO.funcao,
        especialidade: authResponseDTO.especialidade,
        valorDaConsulta: authResponseDTO.valorDaConsulta,
        atendePlano: authResponseDTO.atendePlano,
        atendeParticular: authResponseDTO.atendeParticular,
    });
    const salvarDadosDoUsuario = (event) => {
        event.preventDefault();

        if (
            window.confirm(
                "Para salvar as alterações, faça login novamente agora. Caso não faça login novamente, os dados informados serão perdidos.",
            )
        ) {
            updateFuncionario(dadosDoUsuario, token, authResponseDTO);
            debugger;
            window.location.href = window.location.origin + "/login";
        } else {
            window.location.reload();
            onCloseModal();
        }
    };

    const handleChange = (e) => {
        let { name, value } = e.target;

        if (name.includes("telefone")) {
            value = formatar(
                value,
                /(\d{2})(\d{1})(\d{4})(\d{4})/,
                "($1) $2 $3-$4",
            );
        } else if (name.includes("cpf")) {
            value = formatar(
                value,
                /(\d{3})(\d{3})(\d{3})(\d{2})/,
                "$1.$2.$3-$4",
            );
        } else if (name.includes("atende")) {
            value = e.target.checked;
        }

        setDadosDoUsuario({ ...dadosDoUsuario, [name]: value });
    };

    const adicionarHorario = () => {
        setHorariosConfiguracao((horarios) => {
            const novoHorario = proximoHorarioId.current;
            proximoHorarioId.current += 1;

            return [...horarios, criarHorarioConfiguracao(novoHorario)];
        });
    };

    const excluirHorario = (horarioParaExcluir) => {
        setHorariosConfiguracao((horarios) => {
            const horarioRemovido = horarios.find(
                (horario) => horario.key === horarioParaExcluir,
            );

            if (horarioRemovido?.id) {
                setHorariosRemovidos((horariosRemovidosAtuais) => [
                    ...horariosRemovidosAtuais,
                    horarioRemovido.id,
                ]);
            }

            return horarios.filter(
                (horario) => horario.key !== horarioParaExcluir,
            );
        });
    };

    const atualizarHorario = (horarioParaAtualizar, campo, valor) => {
        setHorariosConfiguracao((horarios) =>
            horarios.map((horario) =>
                horario.key === horarioParaAtualizar
                    ? { ...horario, [campo]: valor }
                    : horario,
            ),
        );
    };

    const validarHorariosConfiguracao = () => {
        const diasSelecionados = horariosConfiguracao.map(
            (horario) => horario.diasDaSemana,
        );

        if (diasSelecionados.some((dia) => !dia)) {
            alert("Informe o dia da semana em todos os horarios.");
            return false;
        }

        const possuiHorarioInvalido = horariosConfiguracao.some(
            (horario) => horario.horaFim <= horario.horaInicio,
        );

        if (possuiHorarioInvalido) {
            alert("A hora final deve ser maior que a hora inicial.");
            return false;
        }

        const possuiDiaDuplicado =
            new Set(diasSelecionados).size !== diasSelecionados.length;

        if (possuiDiaDuplicado) {
            alert("Cada dia da semana deve aparecer apenas uma vez.");
            return false;
        }

        return true;
    };

    const salvarConfiguracaoPerfil = async () => {
        if (!validarHorariosConfiguracao()) {
            return;
        }

        try {
            const remocoes = horariosRemovidos.map((horarioId) =>
                excluirConfiguracaoHorarioMedico(token, horarioId),
            );

            const salvamentos = horariosConfiguracao.map((horario) => {
                const payload = {
                    usuarioId: authResponseDTO.id,
                    diasDaSemana: horario.diasDaSemana,
                    horaInicio: horario.horaInicio,
                    horaFim: horario.horaFim,
                };

                if (horario.id) {
                    return atualizarConfiguracaoHorarioMedico(
                        token,
                        horario.id,
                        payload,
                    );
                }

                return criarConfiguracaoHorarioMedico(token, payload);
            });

            await Promise.all(remocoes);
            await Promise.all(salvamentos);

            const configuracoesAtualizadas =
                await getConfiguracoesHorarioMedicoPorUsuario(
                    token,
                    authResponseDTO.id,
                );

            const configuracoesSemanais =
                configuracoesAtualizadas.filter(isConfiguracaoSemanal);

            setHorariosConfiguracao(
                configuracoesSemanais.length
                    ? configuracoesSemanais.map(mapearConfiguracaoHorario)
                    : [criarHorarioConfiguracao(0)],
            );
            setHorariosRemovidos([]);
            proximoHorarioId.current = configuracoesSemanais.length || 1;
            alert("Configuracao de horarios salva com sucesso.");
        } catch (error) {
            console.error("Erro ao salvar configuracao de horarios:", error);
            alert("Erro ao salvar configuracao de horarios.");
        }
    };

    useEffect(() => {
        if (!isModalOpen || authResponseDTO.funcao === "RECEPCIONISTA") {
            return;
        }

        let isMounted = true;

        const carregarConfiguracoesHorario = async () => {
            try {
                const configuracoes =
                    await getConfiguracoesHorarioMedicoPorUsuario(
                        token,
                        authResponseDTO.id,
                    );

                if (!isMounted) {
                    return;
                }

                const configuracoesSemanais =
                    configuracoes.filter(isConfiguracaoSemanal);

                setHorariosConfiguracao(
                    configuracoesSemanais.length
                        ? configuracoesSemanais.map(mapearConfiguracaoHorario)
                        : [criarHorarioConfiguracao(0)],
                );
                setHorariosRemovidos([]);
                proximoHorarioId.current = configuracoesSemanais.length || 1;
            } catch (error) {
                console.error(
                    "Erro ao carregar configuracao de horarios:",
                    error,
                );
                alert("Erro ao carregar configuracao de horarios.");
            }
        };

        carregarConfiguracoesHorario();

        return () => {
            isMounted = false;
        };
    }, [authResponseDTO.funcao, authResponseDTO.id, isModalOpen, token]);

    function formatar(value, searchValue, replaceValue) {
        const valorInput = value.replace(/\D/g, "");
        const formatado = valorInput
            .replace()
            .replace(searchValue, replaceValue);

        return formatado;
    }

    return (
        <>
            {isModalOpen && (
                <div
                    id="top-right-modal"
                    data-modal-placement="top-right"
                    tabIndex="-1"
                    className="bg-black bg-opacity-50 fixed h-full z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full justify-center items-start flex"
                >
                    <div className="relative w-full max-w-4xl max-h-full">
                        {/* <!-- Modal content --> */}
                        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                            {/* <!-- Modal header --> */}
                            <div className="flex items-start justify-between p-4 border-b rounded-t dark:border-gray-600">
                                <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                                    Configurações
                                </h3>
                                <button
                                    onClick={onCloseModal}
                                    type="button"
                                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                    data-modal-hide="default-modal"
                                >
                                    <svg
                                        className="w-3 h-3"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 14 14"
                                    >
                                        <path
                                            stroke="currentColor"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                        />
                                    </svg>
                                    <span className="sr-only">Close modal</span>
                                </button>
                            </div>
                            {/* <!-- Modal body --> */}
                            <div className="p-6 space-y-6">
                                <div class="md:flex">
                                    <ul class="flex-column space-y space-y-4 text-sm font-medium text-gray-500 dark:text-gray-400 md:me-4 mb-4 md:mb-0">
                                        {authResponseDTO.funcao !==
                                            "RECEPCIONISTA" && (
                                            <li>
                                                <a
                                                    href="#"
                                                    class="inline-flex items-center px-4 py-3 text-white bg-blue-700 rounded-lg active w-full dark:bg-blue-600"
                                                    aria-current="page"
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faCalendarDays}
                                                        className="me-2"
                                                    />
                                                    Agendamento
                                                </a>
                                            </li>
                                        )}
                                    </ul>
                                    <div class="p-6 bg-gray-50 text-medium text-gray-500 dark:text-gray-400 dark:bg-gray-800 rounded-lg w-full">
                                        <form>
                                            <div class="rounded-lg border border-gray-200 bg-gray-50 p-4 dark:border-gray-600 dark:bg-gray-700 mb-6">
                                                <div class="flex justify-between items-center mb-3">
                                                    <span class="text-gray-900 dark:text-white text-base font-medium">
                                                        Horário de atendimento
                                                    </span>
                                                    <label class="inline-flex items-center cursor-pointer">
                                                        {/* 
                                                        //TODO
                                                        // VALIDAR POSTERIORMENTE SE É REALMENTE NECESSÁRIO
                                                        <input
                                                            type="checkbox"
                                                            value=""
                                                            name="business-hours"
                                                            class="sr-only peer"
                                                        />
                                                        <div class="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-600 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"></div> */}
                                                        <span class="sr-only">
                                                            Horário de atendimento
                                                        </span>
                                                    </label>
                                                </div>
                                                <p class="text-sm text-gray-500 dark:text-gray-400 font-normal">
                                                    Criar ou remover os horários de atendimento para os dias da semana.
                                                </p>
                                            </div>
                                            <div class="mb-6 overflow-y-auto h-[calc(100%-1rem)] max-h-full">
                                                {horariosConfiguracao.map(
                                                    (horario) => (
                                                        <DivConfiguracaoAgendamento
                                                            key={horario.key}
                                                            idPrefix={`horario-atendimento-${horario.key}`}
                                                            horario={horario}
                                                            onChange={(
                                                                campo,
                                                                valor,
                                                            ) =>
                                                                atualizarHorario(
                                                                    horario.key,
                                                                    campo,
                                                                    valor,
                                                                )
                                                            }
                                                            onExcluir={() =>
                                                                excluirHorario(
                                                                    horario.key,
                                                                )
                                                            }
                                                        />
                                                    ),
                                                )}
                                                {/* <div class="flex items-center justify-between mb-3">
                                                    <div class="relative max-w-sm">
                                                        <input type="date" id="default-datepicker" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Select date"/>
                                                    </div>
                                                    <div class="w-full max-w-[7rem]">
                                                        <label
                                                            for="start-time-monday"
                                                            class="sr-only"
                                                        >
                                                            Start time:
                                                        </label>
                                                        <div class="relative">
                                                            <input
                                                                type="time"
                                                                id="start-time-monday"
                                                                name="start-time-monday"
                                                                class="bg-gray-50 border leading-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                min="09:00"
                                                                max="18:00"
                                                                value="00:00"
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="w-full max-w-[7rem]">
                                                        <label
                                                            for="end-time-monday"
                                                            class="sr-only"
                                                        >
                                                            End time:
                                                        </label>
                                                        <div class="relative">
                                                            <input
                                                                type="time"
                                                                id="end-time-monday"
                                                                name="end-time-monday"
                                                                class="bg-gray-50 border leading-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                min="09:00"
                                                                max="18:00"
                                                                value="00:00"
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <button
                                                            type="button"
                                                            class="inline-flex items-center p-1.5 text-sm font-medium text-center text-gray-500 hover:text-gray-800 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg focus:outline-none dark:text-gray-400 dark:hover:text-gray-100"
                                                        >
                                                            <svg
                                                                class="w-5 h-5"
                                                                aria-hidden="true"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="24"
                                                                height="24"
                                                                fill="currentColor"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <path
                                                                    fill-rule="evenodd"
                                                                    d="M8.586 2.586A2 2 0 0 1 10 2h4a2 2 0 0 1 2 2v2h3a1 1 0 1 1 0 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a1 1 0 0 1 0-2h3V4a2 2 0 0 1 .586-1.414ZM10 6h4V4h-4v2Zm1 4a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Zm4 0a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Z"
                                                                    clip-rule="evenodd"
                                                                />
                                                            </svg>
                                                            <span class="sr-only">
                                                                Delete
                                                            </span>
                                                        </button>
                                                    </div>
                                                </div> */}
                                            </div>
                                            <button
                                                id="novoHorario"
                                                onClick={adicionarHorario}
                                                type="button"
                                                class="inline-flex items-center justify-center w-full py-2.5 mb-4 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                                            >
                                                <svg
                                                    class="w-4 h-4 me-1"
                                                    aria-hidden="true"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24"
                                                    height="24"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        stroke="currentColor"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M5 12h14m-7 7V5"
                                                    />
                                                </svg>
                                                Novo horário
                                            </button>
                                                {/* <div className="grid grid-cols-2 gap-4 bottom-4 left-0 w-full md:px-4">
                                                    <button
                                                        onClick={onCloseModal}
                                                        type="button"
                                                        className="text-white bg-gradient-to-br from-pink-500 to-orange-400 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-pink-200 dark:focus:ring-pink-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                                    >
                                                        Fechar
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        form="formDadosPerfilFuncionario"
                                                        className="text-white bg-gradient-to-r from-cyan-500 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                                    >
                                                        Salvar
                                                    </button>
                                                </div> */}
                                            {/* <div class="grid grid-cols-2 gap-4 bottom-4 left-0 w-full md:px-4 md:absolute">
                                                <button
                                                    type="button"
                                                    data-drawer-hide="drawer-timepicker"
                                                    class="py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                                                >
                                                    Close
                                                </button>
                                                <button
                                                    type="submit"
                                                    class="text-white w-full inline-flex items-center justify-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                                                >
                                                    Save all
                                                </button>
                                            </div> */}
                                        </form>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="p-6 space-y-6">
                                <form
                                    onSubmit={salvarDadosDoUsuario}
                                    id="formDadosPerfilFuncionario"
                                >
                                    <div className="relative z-0 w-full mb-6 group">
                                        <input
                                            disabled
                                            value={authResponseDTO.username}
                                            name="username"
                                            type="text"
                                            id="nome_completo_usuario"
                                            className="block px-2.5 pb-1.5 pt-3 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer cursor-not-allowed"
                                            placeholder=" "
                                        />
                                        <label
                                            for="nome_completo_usuario"
                                            className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-3 scale-75 top-1 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 cursor-not-allowed peer-placeholder-shown:top-1/2 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3 left-1"
                                        >
                                            Nome completo
                                        </label>
                                    </div>
                                    <div className="grid md:grid-cols-2 md:gap-6">
                                        <div className="relative z-0 w-full group mb-6">
                                            <input
                                                value={dadosDoUsuario.cpfCnpj}
                                                onChange={handleChange}
                                                name="cpfCnpj"
                                                type="text"
                                                id="cpf_usuario"
                                                className="block px-2.5 pb-1.5 pt-3 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                placeholder=" "
                                                maxLength={14}
                                                required
                                            />
                                            <label
                                                for="cpf_usuario"
                                                className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-3 scale-75 top-1 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3 left-1"
                                            >
                                                CPF
                                            </label>
                                        </div>
                                        <div className="relative z-0 w-full group mb-6">
                                            <input
                                                value={
                                                    authResponseDTO.documentoDeIdentificacao
                                                }
                                                disabled
                                                type="text"
                                                name="documentoDeIdentificacao"
                                                id="documento_profissional"
                                                className="cursor-not-allowed block px-2.5 pb-1.5 pt-3 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                placeholder=" "
                                                required
                                            />
                                            <label
                                                for="documento_profissional"
                                                className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 cursor-not-allowed transform -translate-y-3 scale-75 top-1 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3 left-1"
                                            >
                                                Documento profissional
                                            </label>
                                        </div>
                                    </div>
                                    <div className="relative z-0 w-full mb-6 group">
                                        <input
                                            value={dadosDoUsuario.email}
                                            onChange={handleChange}
                                            name="email"
                                            type="email"
                                            id="email_usuario"
                                            className="block px-2.5 pb-1.5 pt-3 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                            placeholder=" "
                                            required
                                        />
                                        <label
                                            for="email_usuario"
                                            className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-3 scale-75 top-1 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3 left-1"
                                        >
                                            E-mail
                                        </label>
                                    </div>
                                    <div className="grid md:grid-cols-2 md:gap-6">
                                        <div className="relative z-0 w-full group mb-6">
                                            <input
                                                value={
                                                    dadosDoUsuario.especialidade
                                                }
                                                onChange={handleChange}
                                                name="especialidade"
                                                type="text"
                                                id="especialidade_usuario"
                                                className={`block px-2.5 pb-1.5 pt-3 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer ${
                                                    authResponseDTO.funcao ===
                                                    "RECEPCIONISTA"
                                                        ? "cursor-not-allowed"
                                                        : ""
                                                }`}
                                                placeholder=" "
                                                disabled={
                                                    authResponseDTO.funcao ===
                                                    "RECEPCIONISTA"
                                                }
                                            />
                                            <label
                                                for="especialidade_usuario"
                                                className={`absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-3 scale-75 top-1 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3 left-1 ${
                                                    authResponseDTO.funcao ===
                                                    "RECEPCIONISTA"
                                                        ? "cursor-not-allowed"
                                                        : ""
                                                }`}
                                            >
                                                Especiaidade
                                            </label>
                                        </div>
                                        <div className="relative z-0 w-full group mb-6">
                                            <input
                                                value={authResponseDTO.funcao}
                                                disabled
                                                type="text"
                                                name="funcao"
                                                id="funcao_profissional"
                                                className="block px-2.5 pb-1.5 pt-3 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer cursor-not-allowed"
                                                placeholder=" "
                                                required
                                            />
                                            <label
                                                for="funcao_profissional"
                                                className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-3 scale-75 top-1 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3 left-1 cursor-not-allowed"
                                            >
                                                Função
                                            </label>
                                        </div>
                                    </div>
                                    <div className="mb-6 grid md:grid-cols-2 md:gap-6">
                                        <div className="relative z-0 w-full group mb-6">
                                            <input
                                                value={dadosDoUsuario.telefone}
                                                onChange={handleChange}
                                                name="telefone"
                                                type="tel"
                                                id="telefone_usuario"
                                                className="block px-2.5 pb-1.5 pt-3 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                placeholder=" "
                                                required
                                            />
                                            <label
                                                for="telefone_usuario"
                                                className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-3 scale-75 top-1 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3 left-1"
                                            >
                                                Telefone
                                            </label>
                                        </div>
                                        <div
                                            className={`relative mb-6 z-0 w-full group ${
                                                authResponseDTO.funcao ===
                                                "RECEPCIONISTA"
                                                    ? "hidden"
                                                    : ""
                                            }`}
                                        >
                                            <input
                                                value={
                                                    dadosDoUsuario.valorDaConsulta
                                                }
                                                onChange={handleChange}
                                                name="valorDaConsulta"
                                                type="number"
                                                id="valor_consulta_usuario"
                                                className="block px-2.5 pb-1.5 pt-3 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                placeholder=" "
                                                required={
                                                    authResponseDTO.funcao !==
                                                    "RECEPCIONISTA"
                                                }
                                            />
                                            <label
                                                for="valor_consulta_usuario"
                                                className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-3 scale-75 top-1 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3 left-1"
                                            >
                                                Valor da consulta
                                            </label>
                                        </div>
                                    </div>
                                    <div
                                        className={`grid mb-6 md:grid-cols-2 md:gap-6 ${
                                            authResponseDTO.funcao ===
                                            "RECEPCIONISTA"
                                                ? "hidden"
                                                : ""
                                        }`}
                                    >
                                        <div className="relative z-0 mb-6 w-full group">
                                            <label className="relative inline-flex items-center cursor-pointer">
                                                <input
                                                    checked={
                                                        dadosDoUsuario.atendePlano
                                                    }
                                                    onChange={handleChange}
                                                    name="atendePlano"
                                                    type="checkbox"
                                                    className="sr-only peer"
                                                />
                                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                                <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">
                                                    Atende plano?
                                                </span>
                                            </label>
                                        </div>
                                        <div className="relative z-0 mb-6 w-full group">
                                            <label className="relative inline-flex items-center cursor-pointer">
                                                <input
                                                    checked={
                                                        dadosDoUsuario.atendeParticular
                                                    }
                                                    onChange={handleChange}
                                                    name="atendeParticular"
                                                    type="checkbox"
                                                    className="sr-only peer"
                                                />
                                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                                <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">
                                                    Atende particular?
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </form>
                            </div> */}
                            {/* <!-- Modal footer --> */}
                            <div className="flex items-center p-6 space-x-2 border-t border-gray-200 rounded-b dark:border-gray-600">
                                <button
                                    onClick={onCloseModal}
                                    type="button"
                                    className="text-white bg-gradient-to-br from-pink-500 to-orange-400 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-pink-200 dark:focus:ring-pink-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                >
                                    Cancelar
                                </button>
                                <button
                                    id="salvarConfiguracaoPerfil"
                                    onClick={salvarConfiguracaoPerfil}
                                    type="button"
                                    // type="submit"
                                    // form="formDadosPerfilFuncionario"
                                    className="text-white bg-gradient-to-r from-cyan-500 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                >
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PerfilConfiguracaoModal;
